import { render, staticRenderFns } from "./Subordinate.vue?vue&type=template&id=54d3375e"
import script from "./Subordinate.vue?vue&type=script&lang=js"
export * from "./Subordinate.vue?vue&type=script&lang=js"
import style0 from "./Subordinate.vue?vue&type=style&index=0&id=54d3375e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports